import * as React from 'react'

import { Code, ConnectError } from '@connectrpc/connect'
import { useRouteError } from 'react-router'

import { PageError } from '@enechain/ecloud-designsystem'

import { ProtectedAuthGuard } from '../ProtectedAuthGuard'

const PERMISSION_DENIED_ERROR_MESSAGE = 'PermissionDenied'

const ErrorLayout: React.FC = () => {
  const error = useRouteError()

  const { message: errorMessage } = error as { message: string }

  if (
    errorMessage !== undefined &&
    errorMessage.includes(PERMISSION_DENIED_ERROR_MESSAGE)
  ) {
    return <PageError kind="403" />
  }

  if (!(error instanceof ConnectError)) {
    return <PageError kind="500" />
  }

  switch (error.code) {
    case Code.NotFound:
      return <PageError kind="404" />
    case Code.Unauthenticated:
      return <PageError kind="401" />
    case Code.PermissionDenied:
      return <PageError kind="403" />
    default:
      return <PageError kind="500" />
  }
}

export default ProtectedAuthGuard(ErrorLayout)
